import { pxToRem } from "@/util";
import { Box, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";

export default function Hero() {
  const { classes } = styles();

  return (
    <Box className={classes.container}>
      <Box className={classes.detCont}>
        <Typography className={classes.head}>Privacy Policy</Typography>
        <Typography className={classes.desc}>
          At AREL (Avvic Real Estate Limited), we value your privacy and are
          committed to protecting your personal data. This Privacy Policy
          outlines how we collect, use, store, and protect your information when
          you interact with our website, services, or team.
        </Typography>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: pxToRem(377),
    position: "relative",
    padding: theme.spacing(4),
    background: "#F7F7FD",

    [theme.breakpoints.down("sm")]: {
      minHeight: pxToRem(420),
      padding: `${pxToRem(20)}`,
    },
  },

  detCont: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    width: "60%",
    alignItems: "center",
    textAlign: "center",

    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  head: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(60),
    color: "#323232",
    lineHeight: "120%",
    width: "80%",

    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(34),
      width: "100%",
      textAlign: "left",
    },
  },
  desc: {
    fontWeight: 400,
    fontSize: pxToRem(20),
    lineHeight: "160%",
    color: "#6A6A6A",
    width: "70%",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: pxToRem(16),
      textAlign: "left",
    },
  },
}));
